export default class BNutriangle
{
	static selector = () => `.nutriangle, .nutriangle-result`;

	static positionCheck(el)
	{
		const fats = parseInt(el.dataset.fats) / 100;
		const carbs = parseInt(el.dataset.carbs) / 100;
		const prots = parseInt(el.dataset.prots) / 100;

		const posX = (fats * 0.5 + carbs * 0 + prots * 1) * 100;
		const posY = (fats * 0 + carbs * 1 + prots * 1) * 100;

		const check = el.querySelector(".check");
		if (check) {
			check.style.left = posX + "%";
			check.style.top = posY + "%";
		}
	}

	static positionAll()
	{
		document.querySelectorAll(this.selector()).forEach(el => {
			this.positionCheck(el);
		});
	}

	static initialize()
	{
		window.nutriangle = () => this.positionAll();

		window.addEventListener("load", () => {
			this.positionAll();
		});

		document.addEventListener("modalSurovinaOpen", () => {
			this.positionAll();
		});
	}
}
